// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';
import { useColorMode } from '@/components/ui/color-mode';

type Props = {
  width?: number;
  fill?: string;
};
export const Telegram = ({ fill = 'none', width = 14 }: Props) => {
  const { colorMode } = useColorMode();
  const fillColor = colorMode === 'light' ? 'black' : 'white';
  return (
    <chakra.svg
      height={`${width}px`}
      width={`${width}px`}
      fill={fill}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.0013 1.1665C3.77886 1.1665 1.16797 3.77739 1.16797 6.99984C1.16797 10.2223 3.77886 12.8332 7.0013 12.8332C10.2237 12.8332 12.8346 10.2223 12.8346 6.99984C12.8346 3.77739 10.2237 1.1665 7.0013 1.1665ZM9.86622 5.16281L8.9089 9.67423C8.83833 9.99412 8.64781 10.0717 8.38201 9.92121L6.92368 8.84627L6.22039 9.52369C6.14277 9.60131 6.07691 9.66718 5.92637 9.66718L6.02986 8.18297L8.73248 5.74144C8.85009 5.63794 8.70661 5.57914 8.55137 5.68263L5.21132 7.78545L3.7718 7.33619C3.45896 7.2374 3.45191 7.02336 3.83766 6.87282L9.46165 4.70414C9.72274 4.61005 9.9509 4.76765 9.86622 5.16281Z"
        fill={fillColor}
        fillOpacity="0.4"
      />
    </chakra.svg>
  );
};
